<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  viewBox="0 0 456.222 456.222"
>
  <!-- Footing -->
  <path
    d="M303.267 415.831h32.68c11.15 0 21.25 4.52 28.56 11.83 7.31 7.31 11.83 17.41 11.83 28.56H79.897c0-22.31 18.08-40.39 40.39-40.39h32.68"
    fill="#51b7ce"
  />

  <!-- Base -->
  <path
    d="M303.265 343.382v80.88c0 2.85-.37 5.62-1.08 8.25-2.58-7.28-9.54-12.5-17.71-12.5-10.37 0-18.79 8.41-18.79 18.78 0-10.37-8.41-18.78-18.78-18.78-10.38 0-18.79 8.41-18.79 18.78 0-10.37-8.41-18.78-18.79-18.78s-18.79 8.41-18.79 18.78c0-10.37-8.41-18.78-18.78-18.78-8.17 0-15.13 5.22-17.71 12.5-.71-2.63-1.08-5.4-1.08-8.25v-80.88c0-17.65 14.31-31.96 31.96-31.96h86.38c17.65 0 31.96 14.31 31.96 31.96z"
    fill="#ef5252"
  />

  <!-- Wings -->
  <path
    d="M455.275 176.392a102.61 102.61 0 0 1-3.7 19.24H4.635a103.46 103.46 0 0 1-3.69-19.23c-.49-5.25 3.67-9.77 8.94-9.77h436.45c5.27 0 9.44 4.52 8.94 9.76z"
    fill="#ef5252"
  />
  <path
    d="M4.635 195.632h446.94c-4.9 16.75-13.96 31.73-25.97 43.75-18.62 18.61-44.34 30.13-72.75 30.13H103.375c-46.74 0-86.21-31.18-98.74-73.88z"
    fill="#f99c38"
  />
  <path
    d="M420.815 195.632c-7.49 17.48-21.53 31.5-39.01 38.97a73.223 73.223 0 0 1-20 5.37c-2.93.36-5.92.54-8.95.54h-249.48c-3.03 0-6.02-.18-8.95-.54a73.223 73.223 0 0 1-20-5.37c-17.48-7.47-31.52-21.49-39.01-38.97h385.4z"
    fill="#f9e17a"
  />

  <!-- Body -->
  <path
    d="M303.265 198.592v80.87c0 16.1-11.91 29.42-27.4 31.63v-69.87c0-9.39-7.61-17-17-17s-17 7.61-17 17v70.2h-27.5v-70.2c0-9.39-7.61-17-17-17s-17 7.61-17 17v69.87c-15.49-2.21-27.4-15.53-27.4-31.63v-80.87c0-14.79 10.04-27.23 23.68-30.87l51.47 42.11 51.47-42.11c13.64 3.64 23.68 16.08 23.68 30.87z"
    fill="#51b7ce"
  />

  <!-- Head -->
  <path
    d="M303.265 53.792v46.04h-.07c-19.24 0-34.84 15.6-34.84 34.84 0 12.25 6.33 23.02 15.89 29.23a31.876 31.876 0 0 1-12.94 2.73h-86.38c-4.61 0-8.99-.98-12.94-2.73 9.56-6.21 15.89-16.98 15.89-29.23 0-19.24-15.6-34.84-34.84-34.84h-.07v-46.04c0-17.65 14.31-31.96 31.96-31.96h86.38c17.65 0 31.96 14.31 31.96 31.96z"
    fill="#f99c38"
  />

  <!-- Base decor -->
  <path
    d="M284.475 420.012c-10.37 0-18.79 8.41-18.79 18.78 0-10.37-8.41-18.78-18.78-18.78-10.38 0-18.79 8.41-18.79 18.78 0-10.37-8.41-18.78-18.79-18.78-10.38 0-18.79 8.41-18.79 18.78 0-10.37-8.41-18.78-18.78-18.78-8.17 0-15.13 5.22-17.71 12.5 3.63 13.65 16.08 23.71 30.88 23.71h86.38c14.8 0 27.25-10.06 30.88-23.71-2.58-7.28-9.54-12.5-17.71-12.5z"
    fill="#f9e17a"
  />
  <circle cx="191.144" cy="349.845" r="15.421" fill="#f9e17a" />
  <circle
    cx="191.144"
    cy="349.845"
    r="8.492"
    fill="#666"
  />
  <circle cx="265.089" cy="349.845" r="15.421" fill="#f9e17a" />
  <circle
    cx="265.089"
    cy="349.845"
    r="8.492"
    fill="#666"
  />
  <path
    d="M281.617 399.631h-107c-5.522 0-10-4.477-10-10s4.478-10 10-10h107c5.522 0 10 4.477 10 10s-4.478 10-10 10z"
    fill="#f99c38"
  />

  <!-- Body decor -->
  <path
    d="m279.585 167.722-51.47 42.11-51.47-42.11c2.64-.71 5.42-1.09 8.28-1.09h86.38c2.86 0 5.64.38 8.28 1.09z"
    fill="#f9e17a"
  />
  <path
    d="M275.865 241.222v69.87c-1.49.22-3.01.33-4.56.33h-29.44v-70.2c0-9.39 7.61-17 17-17s17 7.61 17 17zM214.365 241.222v70.2h-29.44c-1.55 0-3.07-.11-4.56-.33v-69.87c0-9.39 7.61-17 17-17s17 7.61 17 17z"
    fill="#f9e17a"
  />
  <path
    d="M177.115 208.832c-2.63 0-5.21-1.07-7.069-2.93a10.077 10.077 0 0 1-2.931-7.07c0-2.63 1.07-5.21 2.931-7.07a10.072 10.072 0 0 1 7.069-2.93c2.631 0 5.211 1.07 7.07 2.93 1.86 1.86 2.93 4.44 2.93 7.07s-1.069 5.21-2.93 7.07a10.072 10.072 0 0 1-7.07 2.93zM279.115 208.832c-2.63 0-5.21-1.07-7.069-2.93a10.077 10.077 0 0 1-2.931-7.07c0-2.63 1.07-5.21 2.931-7.07a10.072 10.072 0 0 1 7.069-2.93c2.631 0 5.211 1.07 7.07 2.93 1.86 1.86 2.93 4.44 2.93 7.07s-1.069 5.21-2.93 7.07a10.072 10.072 0 0 1-7.07 2.93z"
    fill="#d17519"
  />

  <!-- Head decor -->
  <path
    d="M303.265 99.832v34.84c0 13.04-7.81 24.26-19.02 29.23-9.56-6.21-15.89-16.98-15.89-29.23 0-19.24 15.6-34.84 34.84-34.84h.07z"
    fill="#ef5252"
  />
  <path
    d="M187.875 134.672c0 12.25-6.33 23.02-15.89 29.23-11.21-4.97-19.02-16.19-19.02-29.23v-34.84h.07c19.24 0 34.84 15.6 34.84 34.84z"
    fill="#ef5252"
  />
  <path
    d="M228.117 42.499c-5.522 0-10-4.477-10-10V10c0-5.523 4.478-10 10-10s10 4.477 10 10v22.499c0 5.523-4.478 10-10 10z"
    fill="#666"
  />
  <path
    d="m255.005 125.457-26.89 11.55-26.88-11.55z"
    fill="#f9e17a"
  />
  <path d="M255.005 125.457h-53.77l26.88-26.88z" fill="#ef5252" />
  <circle cx="259.037" cy="74.936" r="27.81" fill="#f9e17a" />
  <circle
    cx="259.037"
    cy="74.936"
    r="16.319"
    fill="#fff"
  />
  <circle cx="259.037" cy="74.936" r="6.473" fill="#666" />
  <circle
    cx="197.196"
    cy="74.936"
    r="27.81"
    fill="#f9e17a"
  />
  <circle cx="197.196" cy="74.936" r="16.319" fill="#fff" />
  <circle
    cx="197.196"
    cy="74.936"
    r="6.473"
    fill="#666"
  />

  <!-- Wings decor -->
  <path
    data-player="true"
    d="M109.822 195.631h20v44.88h-20zM94.425 195.632v44.34a73.223 73.223 0 0 1-20-5.37v-38.97h20zM381.805 195.632v38.97a73.223 73.223 0 0 1-20 5.37v-44.34h20zM326.411 195.631h20v44.88h-20z"
    fill="#4d4d4d"
  />
  <path
    data-player="true"
    d="M36.447 166.632v13.65c0 5.53-4.47 10-10 10-5.52 0-10-4.47-10-10v-13.65h20zM64.117 166.632v13.65c0 5.53-4.48 10-10 10s-10-4.47-10-10v-13.65h20zM91.787 166.632v13.65c0 5.53-4.48 10-10 10-5.53 0-10-4.47-10-10v-13.65h20zM119.447 166.632v13.65c0 5.53-4.47 10-10 10-5.52 0-10-4.47-10-10v-13.65h20zM147.117 166.632v13.65c0 5.53-4.48 10-10 10s-10-4.47-10-10v-13.65h20zM329.114 166.632v13.65c0 5.53-4.47 10-10 10-5.52 0-10-4.47-10-10v-13.65h20zM356.784 166.632v13.65c0 5.53-4.48 10-10 10s-10-4.47-10-10v-13.65h20zM384.454 166.632v13.65c0 5.53-4.48 10-10 10-5.53 0-10-4.47-10-10v-13.65h20zM412.114 166.632v13.65c0 5.53-4.47 10-10 10-5.52 0-10-4.47-10-10v-13.65h20zM439.784 166.632v13.65c0 5.53-4.48 10-10 10s-10-4.47-10-10v-13.65h20z"
    fill="#808080"
  />
</svg>
